import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkantElementsModule } from '@markant/elements-angular';
import { IAMTenant, IamToggleService } from '@markant-platform/shared/iam-toggle/data-access';

@Component({
  selector: 'markant-platform-iam-toggle',
  templateUrl: './iam-toggle.component.html',
  styleUrls: ['./iam-toggle.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MarkantElementsModule],
})
export class IamToggleComponent implements OnInit {
  protected isMarkantCentralTenant = false;

  constructor(private iamToggleService: IamToggleService) {}

  ngOnInit(): void {
    this.isMarkantCentralTenant = this.iamToggleService.isActive(IAMTenant.MARKANT_CENTRAL);
  }

  onCheckedChanged(checked: boolean): void {
    this.iamToggleService.updateTenant(checked ? IAMTenant.MARKANT_CENTRAL : IAMTenant.PLATFORM);
    window.location.replace('/platform');
  }
}
